/**
 * Logging utility for controlled output in the application.
 *
 * Usage:
 *   import { log, warn, error } from '@/utils/logUtils';
 *   log('Debug message'); // Only logs if VITE_DEBUG_LOGS is true
 *   warn('Warning message'); // Only logs if VITE_DEBUG_LOGS is true
 *   error('Error message'); // Always logs errors
 *
 * Set VITE_DEBUG_LOGS in your .env file to control verbosity.
 * Default should be false in production.
 */
// Logging utility for controlled output
const isDebug = import.meta.env.VITE_DEBUG_LOGS === 'true';

export function log(...args) {
  if (isDebug) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function warn(...args) {
  if (isDebug) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}

export function error(...args) {
  // Always log errors, or control with another flag if needed
  // eslint-disable-next-line no-console
  console.error(...args);
} 